<template>
  <div class="page">
    <div class="row secondary-color">
      <div class="container">
        <div class="col s12 m4" v-for="skill in mainSkills" v-bind:key="skill.icon">
          <div class="icon-block">
            <h2 class="center"><i class="material-icons">{{ skill.icon }}</i></h2>
            <h5 class="center">{{ $t(skill.title) }}</h5>
            <p class="light">
              {{ $t(skill.desc) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <h3>{{ $t(transverse.title) }}</h3>
        <ul>
          <li v-for="(text, index) in transverse.list" v-bind:key="index">{{ $t(text) }}</li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <h3>{{ $t(businessLanguages.title) }}</h3>
        <div class="chip" v-for="language in businessLanguages.list" v-bind:key="language.title">
          <img :src="language.img" :alt="language.title">
          {{ language.title }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="container">
        <h3>{{ $t(funLanguages.title) }}</h3>
        <div class="chip" v-for="language in funLanguages.list" v-bind:key="language.title">
          <img :src="language.img" :alt="language.title">
          {{ language.title }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <h3>{{ $t(frameworks.title) }}</h3>
        <div class="chip" v-for="language in frameworks.list" v-bind:key="language.title">
          <img :src="language.img" :alt="language.title">
          {{ language.title }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <h3>{{ $t(tools.title) }}</h3>
        <div class="chip" v-for="language in tools.list" v-bind:key="language.title">
          <img :src="language.img" :alt="language.title">
          {{ language.title }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <h3>{{ $t(others.title) }}</h3>
        <ul>
          <li v-for="(text, index) in others.list" v-bind:key="index" v-html="$t(text)"/>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      mainSkills: [
        {
          icon: 'group',
          title: 'home.agility.title',
          desc: 'home.agility.description'
        },
        {
          icon: 'sentiment_very_satisfied',
          title: 'home.unit.test.title',
          desc: 'home.unit.test.description'
        },
        {
          icon: 'flash_on',
          title: 'home.frameworks.title',
          desc: 'home.frameworks.description'
        }
      ],
      transverse: {
        title: 'home.transverse.title',
        list: ['home.transverse.tdd', 'home.transverse.kanban', 'home.transverse.pairprogramming']
      },
      businessLanguages: {
        title: 'home.business.languages.title',
        list: [
          {img: 'static/img/php.svg', title: 'PHP'},
          {img: 'static/img/java.svg', title: 'Java'},
          {img: 'static/img/android.svg', title: 'Android'},
          {img: 'static/img/html.png', title: 'HTML/CSS/JS'},
          {img: 'static/img/swift.svg', title: 'Swift'},
          {img: 'static/img/sql.png', title: 'SQL'},
          {img: 'static/img/js.png', title: 'JS'}
        ]
      },
      funLanguages: {
        title: 'home.fun.languages.title',
        list: [
          {img: 'static/img/nodejs.svg', title: 'NodeJS'},
          {img: 'static/img/python.svg', title: 'Python'},
          {img: 'static/img/shell.png', title: 'Shell'}
        ]
      },
      frameworks: {
        title: 'home.frameworks.known.title',
        list: [
          {img: 'static/img/symfony.svg', title: 'Symfony'},
          {img: 'static/img/junit.png', title: 'JUnit'},
          {img: 'static/img/phpunit.png', title: 'PHPUnit'},
          {img: 'static/img/native.png', title: 'React Native'},
          {img: 'static/img/redux-react.png', title: 'Redux & React JS'}
        ]
      },
      tools: {
        title: 'home.tools.title',
        list: [
          {img: 'static/img/linux.png', title: 'Linux'},
          {img: 'static/img/idea.png', title: 'IntelliJ Idea'},
          {img: 'static/img/docker.png', title: 'Docker'},
          {img: 'static/img/git.png', title: 'Git'},
          {img: 'static/img/gitlab.png', title: 'Gitlab CI/CD'}
        ]
      },
      others: {
        title: 'home.other.title',
        list: ['home.other.poker', 'home.other.typescript', 'home.other.methodology']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue